import { Link } from 'react-router';

import { LogoStrip } from '../../components/LogoStrip';
import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './about.module.css';

const stats = [
  {
    label: 'years in continuous classroom deployment',
    number: '10',
    suffix: '+',
  },
  {
    label: 'campuses at scale',
    number: '30',
    suffix: '+',
  },
  {
    label: 'subject families covered',
    number: '8',
    suffix: '+',
  },
  {
    label: 'of students using Kudu',
    number: 'Tens of thousands',
    suffix: undefined,
  },
] as const;

const logos = [
  { name: 'UCLA' },
  { name: 'UC San Diego' },
  { name: 'Cal State' },
  { name: 'OpenStax', subtitle: 'OFFICIAL PARTNER' },
] as const;

export function AboutDecade() {
  return (
    <SectionWrapper background="white" data-testid="about-section-decade">
      <div className={styles.sectionStack}>
        <div className={styles.sectionHeader}>
          <p className={styles.eyebrow}>A DECADE IN</p>
          <h2 className={styles.sectionTitle}>
            Built and used with research universities.
          </h2>
          <p className={styles.sectionSubhead}>
            Kudu has been deployed in classrooms continuously since 2016. Its
            content is co-developed with academic partners — never licensed from
            publishers — and its effects on learning have been independently
            studied.
          </p>
        </div>

        <div className={styles.statsGrid}>
          {stats.map((stat) => (
            <article className={styles.statCard} key={stat.label}>
              <p
                className={styles.statNumber}
                data-variant={stat.suffix === undefined ? 'text' : undefined}
              >
                {stat.number}
                {stat.suffix ? (
                  <span className={styles.statSuffix} data-accent="amber">
                    {stat.suffix}
                  </span>
                ) : null}
              </p>
              <p className={styles.statLabel}>{stat.label}</p>
            </article>
          ))}
        </div>

        <div className={styles.logoBlock}>
          <LogoStrip eyebrow="USED AT" logos={logos} />
          <div className={styles.researchFootnote}>
            <p>
              Independently studied by UCLA&apos;s Center for Education
              Innovation and Learning in the Sciences. Findings published in Lu,
              Supriya, Shaked, Simmons, & Kusenko,{' '}
              <cite>Phys. Rev. Phys. Educ. Res.</cite> (2025).
            </p>
            <Link className={styles.inlineResearchLink} to="/research">
              <span>Read the research</span>
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
